/* ---------------------------- programmes api lines ---------------------------- */
export const ProgrammsTemplateApi = '/projects';

/* ---------------------------- clients api line ---------------------------- */
export const ClientTemplateApi = '/clients';
export const removeApiStatusLines = [ProgrammsTemplateApi, ClientTemplateApi];